module.exports = __webpack_public_path__ + "static/media/post.d0a1e4ac.svg";